import React from "react"

const SampleErrorPage: React.FC = () => {
  // This will throw an error when the component renders
  const throwError = () => {
    throw new Error("This is a test error for Sentry")
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Sentry Error Test Page</h1>
      <button onClick={throwError} className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
        Click to throw error
      </button>
    </div>
  )
}

export default SampleErrorPage
